<template>
	<div class="offer-english-name">
		<v-form ref="form">
			<egranty-text-input-field
				:disabled="readonly"
				v-model="valueInternal"
				label="Angielski tytuł"
				for="offer-enflish-name-english-name-offer"
				id="offer-enflish-name-english-name-offer"
				@change="(val) => $emit('input', val)"
			></egranty-text-input-field>
		</v-form>
	</div>
</template>

<script>
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";

	export default {
		name: "OfferEnglishName",
		components: {EgrantyTextInputField},
		methods: {
			validate() {
				return this.$refs['form'].validate();
			}
		},

		data() {
			return {
				valueInternal: ""
			};
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					this.valueInternal = val;
				}
			}
		},

		props: {
			value: String,
			readonly: {
				default: false
			}
		},
	};
</script>

<style scoped>
	.offer-english-name {
		padding-left: 20px;
		padding-right: 20px;
		margin-bottom: 20px;
	}

</style>
